import React from 'react';
import {_GPY} from './env.js'

class Version extends React.Component {
  render () {return (<span>{_GPY.uiStates.version}-360{process.env.NODE_ENV === 'development' ?" | React : "+React.version:""}</span>)}
}
export default Version;
